"use client";
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/offer.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from "react-bootstrap";
import https from "https";
import { useState, useEffect } from "react";
import Loading from "./loading";
import { formatEventDate } from "@/app/utils/formatDate";
import CodeDisplay from "@/app/utils/content";
import CaroeuslOffer from "@/app/components/offer-carousel";
import CaroeuslOfferImages from "@/app/components/offer-images";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData(slug) {
  const query = `
{
  pageData: qleventofferBy(uri: "${slug}") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    eventsOffers {
      content
      detailsList {
        description
        title
        listIcon {
          node {
            mediaItemUrl
          }
        }
      }
      endDate
      startDate
      customizeDateText
      reserveLink
      featureImage {
        node {
          mediaItemUrl
        }
      }
      detailsOffersInner {
        contentSet
        titleContentSet
      }
      downloadMenuOffer {
        node {
          mediaItemUrl
        }
      }
    }
    taxoffers {
      nodes {
        name
      }
    }
    title
  }
  globalSettings {
    globalSettingsNew {
      postMainTitle
      offersPostImages {
        nodes {
          mediaItemUrl
        }
      }
    }
  }
}
  `;

  const res = await fetch(`${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`, {
    httpsAgent: agent,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
    next: {
      revalidate: 60,
    },
  });
  const { data } = await res.json();

  return data;
}

export default async function EventsOffersInner({ params }) {
  const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [offer_title, setOfferTitle] = useState("");
  const [offer_tags, setOfferTags] = useState([]);
  const [offer_details, setOfferDetails] = useState([]);
  const [offer_content, setOfferContent] = useState("");
  const [offer_date, setOfferDate] = useState("");
  const [offer_link, setOfferLink] = useState("");
  const [innerOffer_menu, setDownloadMenuOffer] = useState("");
  const [offer_details_inner, setDetailsOffersInner] = useState([]);

  const [global_setting, setGlobalSetting] = useState(null);
  const [postMainTitle, setpostMainTitle] = useState("");
  const [iframeLink, setIframeLink] = useState("");
  const [iframeName, setIframeName] = useState("");
  const [offersPostImages, setOffersPostImages] = useState([]);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    async function fetchData() {
      if (params.slug) {
        const query = `/seen-events-offers/${params.slug}/`;
        const page = await getPageData(query);

        if (page) {
          // console.log(page);
          if (page.pageData) {
            setPageData(page.pageData);

            if (page.pageData.title) {
              if (page.pageData.title) {
                setOfferTitle(page.pageData.title);
              }
            }

            if (page.pageData.pageBan) {
              if (page.pageData.pageBan.bannerText) {
                setPageBannerText(page.pageData.pageBan.bannerText);
              }
              if (page.pageData.pageBan.bannerSlider) {
                setPageBannerSliders(page.pageData.pageBan.bannerSlider);
              }
            }

            let start_date = "";
            let end_date = "";
            let custom_date = "";

            if (page.pageData.eventsOffers) {
              if (page.pageData.eventsOffers) {
                if (page.pageData.eventsOffers.startDate) {
                  start_date = page.pageData.eventsOffers.startDate;
                }
                if (page.pageData.eventsOffers.customizeDateText) {
                  custom_date = page.pageData.eventsOffers.customizeDateText;
                }
                if (page.pageData.eventsOffers.endDate) {
                  end_date = page.pageData.eventsOffers.endDate;
                }
                if (page.pageData.eventsOffers.detailsList) {
                  setOfferDetails(page.pageData.eventsOffers.detailsList);
                }
                if (page.pageData.eventsOffers.content) {
                  setOfferContent(page.pageData.eventsOffers.content);
                }
                if (page.pageData.eventsOffers.reserveLink) {
                  setOfferLink(page.pageData.eventsOffers.reserveLink);
                }
                if (page.pageData.eventsOffers.downloadMenuOffer) {
                  if (page.pageData.eventsOffers.downloadMenuOffer.node) {
                    if (
                      page.pageData.eventsOffers.downloadMenuOffer.node
                        .mediaItemUrl
                    ) {
                      setDownloadMenuOffer(
                        page.pageData.eventsOffers.downloadMenuOffer.node
                          .mediaItemUrl,
                      );
                    }
                  }
                }
                if (page.pageData.eventsOffers.detailsOffersInner) {
                  setDetailsOffersInner(
                    page.pageData.eventsOffers.detailsOffersInner,
                  );
                }
              }
            }

            if (page.globalSettings) {
              if (page.globalSettings.globalSettingsNew) {
                setGlobalSetting(page.globalSettings.globalSettingsNew);

                if (page.globalSettings.globalSettingsNew.postMainTitle) {
                  setpostMainTitle(
                    page.globalSettings.globalSettingsNew.postMainTitle,
                  );
                }
                if (page.globalSettings.globalSettingsNew.offersPostImages) {
                  const images =
                    page.globalSettings.globalSettingsNew.offersPostImages.nodes.map(
                      (node) => node.mediaItemUrl,
                    );
                  setOffersPostImages(images);
                }
                if (page.globalSettings.globalSettingsNew.reservationLink) {
                  setIframeLink(
                    page.globalSettings.globalSettingsNew.reservationLink,
                  );
                }
                if (
                  page.globalSettings.globalSettingsNew.reservationIframeName
                ) {
                  setIframeName(
                    page.globalSettings.globalSettingsNew.reservationIframeName,
                  );
                }
              }
            }

            const eventDateText = formatEventDate(
              start_date,
              end_date,
              custom_date,
            );
            if (eventDateText) {
              setOfferDate(eventDateText);
            }

            if (page.pageData.taxoffers) {
              if (page.pageData.taxoffers.nodes) {
                setOfferTags(page.pageData.taxoffers.nodes);
              }
            }
          }
          setPreLoaderEnable(false);
        }
      }
    }
    fetchData();
    return () => {};
  }, [params.slug]);

  useEffect(() => {
    (async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default;
      const locomotiveScroll = new LocomotiveScroll();
    })();
  }, []);

  if (pre_loader_enabled) {
    return <Loading />;
  }

  return (
    <>
      <section className="inner-banner position-relative">
        {page_banner_sliders && (
          <CaroeuslOffer page_banner_sliders={page_banner_sliders} />
        )}
      </section>
      {page_banner_sliders && (
        <section className="bg-dark-green green-mesh  inner-banner-text-wrap position-relative">
          <div className="inner-banner-text z-top">
            <h2 className="all-caps section-heading-large section-heading--yellow m-0">
              {page_banner_text}
            </h2>
          </div>
        </section>
      )}

      {/* new design content */}

      <section
        className={`${styles.OfferInner_Details} bg-dark-green green-mesh  section-padding-bottom`}
      >
        <div className="middle-wrap">
          <div className={`${styles.wrapperInnerOffer} d-flex`}>
            <div className={styles.InerOferLeft}>
              <div className={`d-flex ${styles.offer_box_details}`}>
                <div className={styles.listIcons}>
                  <Image
                    src="/calender.png"
                    width={24}
                    height={23}
                    alt="calender"
                  />
                </div>
                <div className={styles.listData}>
                  <p className="paragraph-small paragraph--white para-bold before-icon">
                    Date
                  </p>
                  <p className="paragraph-small paragraph--white">
                    {offer_date}
                  </p>
                </div>
              </div>
              {offer_details &&
                offer_details.map((offer, index) => {
                  let listIconImage = "";
                  if (offer.listIcon) {
                    if (offer.listIcon.node) {
                      if (offer.listIcon.node.mediaItemUrl) {
                        listIconImage = offer.listIcon.node.mediaItemUrl;
                      }
                    }
                  }
                  return (
                    <div
                      className={`d-flex ${styles.offer_box_details}`}
                      key={index}
                    >
                      <div className={styles.listIcon}>
                        <Image
                          src={listIconImage}
                          width={26}
                          height={26}
                          alt="calender"
                        />
                      </div>
                      <div className={styles.listData}>
                        <p className="paragraph-small paragraph--white para-bold before-icon caps">
                          {offer.title}
                        </p>
                        <div className="paragraph-small paragraph--white discriptionlistdata">
                          <CodeDisplay code={offer.description} />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div>
              <hr className={styles.ofLine}></hr>
            </div>
            <div className={styles.InerOferRight}>
              <div className="d-flex flex-wrap tag-wrap-inner">
                {offer_tags.length !== 0 &&
                  offer_tags.map((tag, index) => (
                    <div className={styles.offer_box_right_tag} key={index}>
                      {tag.name}
                    </div>
                  ))}
              </div>
              <h1 className="section-heading section-heading--white heading-padding all-caps">
                {offer_title}
              </h1>
              <div className={styles.oferInerDiscription}>
                <CodeDisplay code={offer_content} />
              </div>
              <div className={`d-flex ${styles.btn_inerOffer}`}>
                {innerOffer_menu && (
                  <div
                    className={`d-flex z-top button-menu justify-content-center ${styles.btn_inerOfferDown} `}
                  >
                    <Link
                      target="_blank"
                      className={`${styles.download_menu} next-btn next-btn--yellow`}
                      href={innerOffer_menu}
                    >
                      <span
                        className={`all-caps ${styles.span_menuNameOffers}`}
                      >
                        download menu
                      </span>
                      <Image
                        src="/down-arr-w.png"
                        width={15}
                        height={10}
                        alt="Down arrow"
                      />
                    </Link>
                  </div>
                )}
                {offer_link && (
                  <div className={styles.reservNow}>
                    <Link
                      href={offer_link}
                      target="_blank"
                      className={`reserve-btn reserve-btn--yellow ${styles.reserve_now}`}
                    >
                      reserve now
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`${styles.offersInerPoints} section-padding-bottom green-mesh`}
      >
        <div className="middle-wrap">
          <div className={styles.pointsWraper}>
            {offer_details_inner &&
              offer_details_inner.map((offerPoints, index) => {
                return (
                  <div
                    className={`d-flex ${styles.offer_box_details}`}
                    key={index}
                  >
                    <div className={styles.listData}>
                      <p
                        className={`paragraph-small paragraph--white para-bold before-icon all-caps ${styles.titleContentSet}`}
                      >
                        {offerPoints.titleContentSet}
                      </p>
                      <div
                        className={`paragraph-small text-left-mobile paragraph--white ${styles.contentSetList}`}
                      >
                        <CodeDisplay code={offerPoints.contentSet} />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      <CaroeuslOfferImages
        postMainTitle={postMainTitle}
        offersPostImages={offersPostImages}
      />
      {/* end new design content */}
    </>
  );
}
